// "Appears often / Sometimes / Rarely" chip — the CWY Design System's
// ascending-bars frequency badge, shared by the Practice topic picker and
// Home's subject/topic browser.
import type { FrequencyTier } from '@/lib/frequency';

const META: Record<FrequencyTier, { label: string; bars: number }> = {
  High: { label: 'Appears often', bars: 3 },
  Medium: { label: 'Sometimes', bars: 2 },
  Low: { label: 'Rarely', bars: 1 },
};

function Bars({ n }: { n: number }) {
  return (
    <svg width={13} height={13} viewBox="0 0 24 24" fill="currentColor" style={{ display: 'block', flex: 'none' }} aria-hidden="true">
      <rect x={2} y={14} width={4} height={7} rx={1} opacity={n >= 1 ? 1 : 0.28} />
      <rect x={10} y={9} width={4} height={12} rx={1} opacity={n >= 2 ? 1 : 0.28} />
      <rect x={18} y={4} width={4} height={17} rx={1} opacity={n >= 3 ? 1 : 0.28} />
    </svg>
  );
}

export function FrequencyBadge({ tier }: { tier: FrequencyTier }) {
  const m = META[tier];
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-fs-11 font-bold"
      style={{ color: 'var(--ink-2)', background: 'var(--paper-sunk)' }}
    >
      <Bars n={m.bars} />
      {m.label}
    </span>
  );
}
